import Vue from "vue";
import Vuex from "vuex";

/**
 * Initialization of default storage modules
 */
import user from "./store/user.module";
import lastapimessage from "./store/lastapimessage.module";
import app from "./store/app.modules";
import construction from "./store/construction.module";
import lightbox from "./store/lightbox.module";
import division from "./store/division.module";
import projectslist from "./store/projectslist.module";
import bills from "./store/bills.modules";
import company from "./store/company.module";
import subcontractors from "./store/subcontractors.module";
import materials from "./store/materials.module";
import issuances from "./store/issuances.modules";
import deliveries from "./store/deliveries.modules";
import opos from "./store/opos.modules";
import products from "./store/products.module";
import offers from "./store/offers.module";

/**
 * Install a Vue.js plugin
 * https://vuejs.org/v2/api/#Vue-use
 */
Vue.use(Vuex);

/**
 * Export Vuex store object for vue App
 */
export default new Vuex.Store({
  strict: process.env.NODE_ENV !== "production",
  modules: {
    user,
    lastapimessage,
    app,
    construction,
    division,
    lightbox,
    projectslist,
    bills,
    company,
    subcontractors,
    materials,
    issuances,
    deliveries,
    opos,
    products, 
    offers
  }
  // state: {},
  // mutations: {},
  // actions: {}
});